export function sanitizeInput(str: any) {
  if (typeof str !== 'string') return str;

  str = str.trim();

  // 1. Remove ALL HTML tags along with their content (e.g., <h1>test</h1> -> removes everything)
  str = str.replace(/<[^>]+>[\s\S]*?<\/[^>]+>/gi, '');

  // 2. Remove single/self-closing tags (like <br>, <img>, etc.)
  str = str.replace(/<[^>]+>/gi, '');

  // 3. Remove event handlers and dangerous attributes
  str = str.replace(/on\w+="[^"]*"/gi, '');
  str = str.replace(/javascript:/gi, '');
  str = str.replace(/data:text\/html.*,/gi, '');
  str = str.replace(/vbscript:/gi, '');

  // 4. Decode entities and remove &#x...;
  try {
    str = decodeURIComponent(str);
  } catch (e) {}
  str = str.replace(/&#x?[0-9A-F]+;?/gi, '');

  // 5. Remove dangerous standalone keywords
  const blackList = ['script', 'iframe', 'object', 'embed', 'form', 'input'];
  blackList.forEach((word) => {
    const re = new RegExp(word, 'gi');
    str = str.replace(re, '');
  });

  // 6. Remove links starting with http or https
  str = str.replace(/https?:\/\/[^\s]+/gi, '');

  return str;
}
